export default "__VITE_ASSET__nlH6G1Kw__"